export const public_env = {
  ENVIRONMENT: 'prod',
  API_ENDPOINT: 'https://api.propelsia.ai',
  STRIPE_PUBLISHABLE_KEY:
    'pk_live_51NZ8OiGBLjoMYoHKgPUlaH7DXZGcGPl0ZDFORWpOrdRSKGvcpP4V6KufA2gsGuJqtOeyBA4fDYtAsSr5G9KKKC2B003eQd3Srs',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAJqYb6_VkBxzN01wqAhihKLztkgqt0R8Y',
  PAYMENT_TIMEOUT_MS: 600000,
  PRE_BOOKING_TIMEOUT_MS: 600000,
  CURRENCY: 'eur',
  PLAUSIBLE_DOMAIN: 'propelsia.site',
  PLAUSIBLE_SCRIPT_URL: 'https://plausible.propelsia.com/js/script.pageview-props.js',
  MAPTILER_API_KEY: 'gZcoC7vaviVELHa7Fc85',
  CUSTOM_WEBSITES_BASE_URL: 'https://propelsia.site',
  // Base URL de l'app pro (où vit l'inscription). Utilisée par le CTA de la bannière
  // du site preview pour pointer DIRECTEMENT sur le register (funnel preview→compte),
  // sans rebond par une page marketing externe qui pourrait perdre le `?pt=`.
  APP_BASE_URL: 'https://app.propelsia.ai',
  ADMIN_ORIGINS: ['https://admin.propelsia.ai'] as string[],
  // Vitrine Propelsia (LP). Sert de targetOrigin au postMessage chat → LP
  // (widget_first_message) et à la validation d'origine côté LP.
  LP_BASE_URL: 'https://propelsia.ai',
  // Pixel TikTok Propelsia (id public, pas un secret). Vide = destination TikTok
  // jamais enregistrée, SDK jamais chargé. Candidat v1 : D158OVBC77UCOE1UEPC0 —
  // à CONFIRMER comme actif et rattaché à la bonne entité avant de le poser ici
  // (cf. tracking-unification-plan lot 3).
  TIKTOK_PIXEL_ID: 'D158OVBC77UCOE1UEPC0',
  // Pixel OpenAI Ads (publicités ChatGPT) — id public, pas un secret. Vide = SDK
  // jamais chargé et destination `openai-pixel` jamais enregistrée.
  OPENAI_PIXEL_ID: 'QeXUVTLvquTReoUnK163rP',
  // Code de vérification Bing Webmaster Tools (`<meta name="msvalidate.01">`), propre au compte
  // Microsoft technique de Propelsia et identique pour tous ses sites : injecté dans le <head> de
  // tous les sites clients et de la LP. Vide = balise absente, enrôlement Bing impossible.
  BING_SITE_VERIFICATION_CODE: '15DBA9513F37E20E3E0EE8BB06B026D8',
  // Prélèvement SEPA côté pros (option « Ajouter un mandat »). Miroir d'affichage de l'interrupteur
  // backend `SEPA_ENABLED` (la garde réelle) : les deux doivent être alignés. prod : SEPA ÉTEINT tant que la recette sandbox et les prérequis live (doc sepa-gocardless.md §7) ne sont pas faits.
  SEPA_ENABLED: false,
  WIDGET_BUNDLE_URL: 'https://widget.propelsia.ai/booking.js',
  GIFT_CARD_WIDGET_BUNDLE_URL: 'https://widget.propelsia.ai/gift-card.js',
  // PostHog (Cloud EU).
  POSTHOG_KEY: 'phc_oYbd2bPVoEjLzRRr4mUyaj5GwqpfKAxYWmLDoEqVPoko',
  POSTHOG_UI_HOST: 'https://eu.posthog.com',
  // Formulaire externe de bascule Cfixé → Propelsia (cohorte bêta en migration).
  MIGRATION_FORM_URL: 'https://noco.cfixe.app/nc/form/bee4cf33-f626-4ae5-ac9a-40d11189b5fb',
  // Page tarifs publique de la vitrine Propelsia.
  PROPELSIA_PRICING_URL: 'https://propelsia.ai/pricing/',
  // Site de documentation utilisateur (Nextra, généré depuis les manifestes de features).
  DOCS_SITE_URL: 'https://help.propelsia.ai',
  // Webmail Propelsia (Roundcube brandé). Ouvert dans un nouvel onglet depuis la
  // page Emails pro (pas d'iframe, pas de SSO) — le pro s'y connecte lui-même.
  WEBMAIL_URL: 'https://webmail.propelsia.ai',
  // Origine du Chatwoot self-hosted, SEULE autorisée à encadrer la mini-app admin
  // (`/[locale]/chatwoot-app`) — cf. `frame-ancestors` dans admin-web/src/middleware.ts.
  // Vide = aucune origine tierce autorisée (l'admin reste non encadrable).
  CHATWOOT_APP_ORIGIN: 'https://chatwoot.propelsia.com',
  // Dossier Pennylane de production (cf. public_env.ts).
  PENNYLANE_COMPANY_ID: '23585630',
  // OTA app mobile — serveur XPREM self-hosted (protocole Expo Updates v1).
  // ⚠️ FIGÉ dans le binaire store (Expo.plist / AndroidManifest) : changer l'URL
  // impose un nouveau build store. Même serveur pour prod et preprod, la
  // séparation se fait par le header `expo-channel-name` (= APP_ENV).
  UPDATES_ENDPOINT: 'https://updates.propelsia.ai/manifest',
  // UUID de l'app dans le dashboard XPREM (mode control plane), envoyé en header
  // `expo-app-id` — figé dans le binaire lui aussi (créée le 20/08/2026, certificat
  // versionné dans packages/mobile/certs/certificate.pem).
  OTA_APP_ID: '457610b5-9422-436f-9cdf-c68f2f0e4d9c',
};
